export default function initContactScript()
{
	if (!window.location.hash)
		return;

	const departmentEl = document.querySelector(`.contact_departments ${window.location.hash}`);

	if (!departmentEl)
		return;

	const heading = jQuery(`.contact_departments ${window.location.hash} .heading`);

	jQuery(heading).next().slideToggle();
	jQuery(heading).toggleClass("in");
	setTimeout(() =>
	{
		departmentEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}, 500);
}
